import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AddItemApi,
  AddItemFromCSVApi,
  deleteItemApi,
  EditItemApi,
  getItemListApi,
} from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";
import {
  AddItemArgs,
  AddItemCSVArgs,
  EditItemArgs,
  GetItemListApiArgs,
  ItemData,
} from "types/item.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

export const getItems = createAsyncThunk<
  ApiResponse<PaginatedPayload<ItemData>>, // return type
  GetItemListApiArgs | undefined, // argument type
  { rejectValue: string } // rejected type
>("items/getItems", async (params, { rejectWithValue }) => {
  try {
    const response = await getItemListApi(params);
    console.log(params, "getItemListApi", response);
    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const deleteItem = createAsyncThunk<
  ApiResponse<number>, // return type
  number, // argument type
  { rejectValue: string } // rejected type
>("items/deleteItem", async (itemId, { rejectWithValue }) => {
  try {
    const response = await deleteItemApi(itemId);
    response.payload = itemId;
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to delete");
  }
});

export const addItem = createAsyncThunk<
  ApiResponse<ItemData>, // return type
  AddItemArgs, // argument type
  { rejectValue: string } // rejected type
>("items/addItem", async (params, { rejectWithValue }) => {
  try {
    const response = await AddItemApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to add");
  }
});

export const editItem = createAsyncThunk<
  ApiResponse<ItemData>, // return type
  EditItemArgs, // argument type
  { rejectValue: string } // rejected type
>("items/editItem", async (params, { rejectWithValue }) => {
  try {
    const response = await EditItemApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to edit");
  }
});

export const addItemFromCSV = createAsyncThunk<
  ApiResponse<PaginatedPayload<ItemData>>, // return type
  AddItemCSVArgs, // argument type
  { rejectValue: string } // rejected type
>("items/addItemFromCSV", async (params, { rejectWithValue }) => {
  try {
    const response = await AddItemFromCSVApi(params);
    SuccessToast(response.message);

    if (response.result) {
      let fetchItems = await getItemListApi({ page: params.existPage });
      return fetchItems;
    } else {
    }
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to add from CSV");
  }
});
